export default __webpack_public_path__ + "static/media/ic_Rapa_Nui.74b8e687.svg";